import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const deviceManagerClientRoutes = [
  {
    id: 'devices-list',
    trackingName: 'Devices List',
    path: 'dl/view/device-manager/device-list',
    lazy: async () => ({
      Component: (await import('@cash-web/account-device-manager-feature-main')).JourneyDeviceList,
    }),
  },
  {
    id: 'devices-device',
    trackingName: 'Devices Device Details',
    path: 'dl/view/device-manager/device-details/:hashedAppToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-device-manager-feature-main')).JourneyDeviceDetails,
    }),
  },
  {
    id: 'devices-device-removal-confirmation',
    trackingName: 'Devices Device Removal Confirmation',
    path: 'web/view/device-manager/remove-all',
    lazy: async () => ({
      Component: (await import('@cash-web/account-device-manager-feature-main')).JourneyDevicesRemovalConfirmation,
    }),
  },
  {
    id: 'devices-device-removed',
    trackingName: 'Devices Device Removed',
    path: 'web/view/device-manager/device-removed',
    lazy: async () => ({
      Component: (await import('@cash-web/account-device-manager-feature-main')).JourneyDeviceRemoved,
    }),
  },
  {
    id: 'devices-device-error',
    trackingName: 'Devices Device Error',
    path: 'web/view/device-manager/error',
    lazy: async () => ({
      Component: (await import('@cash-web/account-device-manager-feature-main')).JourneyDevicesError,
    }),
  },
] as const satisfies JourneyRoute[]
